import {$, _, Backbone} from "backboneAdapter";
import Handlebars from 'handlebars';
import i18n from 'l10n';
import Template from 'js/templates/fileupload.hbs';
import FileRowView from 'js/views/file.row.view';
import CustomFieldsView from 'js/views/custom.fields.view';
import moment from 'moment-timezone';
import vcardjs from 'vcardjs';
import callingcode from 'callingcodewithdefaultcountry';
import dhtmlx from 'dhtmlxAdapter';
import makeAsync from 'callbackToPromise';
import xlsx from 'xlsx';
import Papa from 'papaparse';
import MetaWorker from 'js/workers/meta.worker';
import {emailRegex} from "js/util";
import {calculateStats, calculatorInitializer, metaCalculator} from "meta.calculator";
import {el, handles, on, template} from "../adapters/backbone-decorators";

require('interfaceAdapter');
require('metroHelpers');

const uploadOptionsTemplate = Handlebars.compile(require("templates/partials/contact.upload.options.hbs"));
const uploaderTemplate = Handlebars.compile(require("templates/partials/contact.uploader.hbs"));

const contactRowPartial = Handlebars.compile("{{#each data}}{{>contact @root row=this rowIndex=@index}}{{/each}}");
const importStatsPartial = Handlebars.compile("{{>importMessagesPartial this}}");
const asyncPapaParse = makeAsync(Papa.parse, {success: "complete", error: "error"});

const _getDroppedFiles = async function (dataTransfer) {
    dataTransfer = dataTransfer || {};
    let items = dataTransfer.items;
    if (items && items.length && (items[0].webkitGetAsEntry ||
        items[0].getAsEntry)) {
        return await _handleFileTreeEntries(
            _.map(items, function (item) {
                let entry;
                if (item.webkitGetAsEntry) {
                    entry = item.webkitGetAsEntry();
                    if (entry) {
                        // Workaround for Chrome bug #149735:
                        entry._file = item.getAsFile();
                    }
                    return entry;
                }
                return item.getAsEntry();
            })
        );
    }
    return _.toArray(dataTransfer.files);
};

const _handleFileTreeEntry = async function (entry, path) {
    let dirReader, entries = [],
        errorHandler = function (e) {
            if (e && !e.entry) {
                e.entry = entry;
            }
            return [e];
        },
        successHandler = async function (entries) {
            try {
                return await _handleFileTreeEntries(
                    entries,
                    `${path + entry.name}/`
                );
            } catch (e) {
                return errorHandler(e);
            }
        },
        readEntries = async function () {
            const readEntriesAsync = makeAsync(dirReader.readEntries.bind(dirReader), {mode: "push"});
            try {
                const results = await readEntriesAsync();
                if (!results.length) {
                    return await successHandler(entries);
                } else {
                    entries = entries.concat(results);
                    return await readEntries();
                }
            } catch (e) {
                return errorHandler(e);
            }
        };
    path = path || '';
    if (entry.isFile) {
        if (entry._file) {
            // Workaround for Chrome bug #149735
            entry._file.relativePath = path;
            return entry._file;
        } else {
            const asyncFH = makeAsync(entry.file.bind(entry), {mode: "push"});
            try {
                const file = await asyncFH();
                file.relativePath = path;
                return file;
            } catch (e) {
                return errorHandler(e);
            }
        }
    } else if (entry.isDirectory) {
        dirReader = entry.createReader();
        return await readEntries();
    } else {
        // Return an empy list for file system items
        // other than files or directories:
        return [];
    }
};

const _handleFileTreeEntries = function (entries, path) {
    const iterable = entries.map(e => _handleFileTreeEntry(e, path));
    return Promise.all(iterable);
};

@el("#file-upload-container")
@template(Template)
class FileUploadView extends Backbone.View {

    className = "row";
    fileRowViewsLength = 0;
    fileTitle = '';
    regexHelpers = {
        excessiveSpaces: new RegExp(/^\s+|\s+(?=\s)|\s+$/g),
        isMobile: new RegExp(/^\+?[\d\s\-()]+$/)
    };

    constructor(options) {
        super();
        if (this.customEvents) {
            this.on(this.customEvents, this)
        }
        console.info("fileupload.view init with options", options);
        this.moreHelp = require(`../templates/${i18n.language}.contactshelp.static.htm`);
        this.initEverythingElse();
    }

    render() {
        this.$el.html(this.template({}));
        if (this.myDomId) {
            var id = this.myDomId();
            this.$el.attr("id", id);
        }
        this.$('[data-i18n]').i18n();
    }

    @on("click #contacts-help-button")
    contactsHelp() {
        dhtmlx.message(this.moreHelp, "alert", undefined, "contacts-help-modal");
        $("#file-upload").find(".tellytile-titlebig").text(i18n.t("contacts.otherfile"));
        $("body").delegate("#moreHelpUpload", "click", (e) => {
            e.preventDefault();
            this.browseFile();
        });
    }

    async sync(provider) {
        const url = '/CampaignCloud/oauthClient/startAuthentication';
        const formValues = {
            provider: provider,
            state: "importContacts",
            groupId: this.groupIdProperty
        };
        console.info(formValues);
        try {
            const {status, LocationUri} = await $.ajaxDefaultQ({
                url: url,
                type: 'POST',
                dataType: "json",
                data: formValues
            });
            if (status === 'success') {
                console.info(LocationUri);
                window.open(LocationUri, '_self');
            } else if (status === 'fail') {
                dhtmlx.alert(i18n.t("login.registrationerror"));
            }
        } catch (e) {
            console.info(e);
        }
    }

    @on('click #google-sync')
    async googleSync() {
        await this.sync(0);
    }

    @on('click #yahoo-sync')
    async yahooSync() {
        await this.sync(1);
    }

    @on('click #hotmail-sync')
    async hotmailSync() {
        await this.sync(2);
    }

    abort() {
        // reset the "flag", or else the "parsing" box, will appear but no parsing will be happening at all, up until the user drops another file (which will most probably won't do
        this.flag = 0;
        if (this.file && this.file.innerView)
            this.file.innerView.abort(i18n.t('fileup.aborted'));
        this.resetFile();
        $('#spinner-process-contacts').hide();
        $('#contact-parsing-finished').hide();
    }

    handleGroupModelChange(model, data) {
        this.groupIdProperty = data.id;
        this.groupType = data.groupType;
    }

    resetFile() {
        this.data = null;
        this.file = null;
        this.fileTitle = "";
        this.$('#flags-counters th').remove();
        this.$('#upload-options').hide();
        this.$('#parsed-file').empty();
        this.$('#parsed-file').css("height", "initial");
        location.href = `#${this.groupIdProperty ? "Group/" + this.groupIdProperty : ""}`;
    }

    initEverythingElse() {
        this.fileAPISupport = this.checkForFileAPISupport();
        this.render();
        this.flag = 0;
        $('#upload-options').hide();
        $('.start').hide();

        this.fileRowViewsCounter = 0;

        $(".paste").on('paste', this.pasteContactsHandler.bind(this));
        $(document).on('dragover', function (e) {
            e.dataTransfer = e.originalEvent && e.originalEvent.dataTransfer;
            if (!e.dataTransfer) return;
            e.preventDefault();
        });
        $(document).on('drop', this.dropContactsHandler.bind(this));
        this.$('.browse-file input').on('change', async e => {
            e.preventDefault();
            if (this.groupType === "query") {
                await dhtmlx.alert(i18n.t("fileup.cannotuploadtoquerygroup"));
                return;
            }
            let file = this.file = e.currentTarget.files && e.currentTarget.files[0];
            this.addFile(e, {file});
        });

        this.$('.progress-bar').css({
            "visibility": "hidden"
        });
        $(".heading").bind("click", this.toggleHelpAccordionText);
    }

    async dropContactsHandler(e) {
        e.dataTransfer = e.originalEvent && e.originalEvent.dataTransfer;
        if (!e.dataTransfer) return;
        var dataTransfer = e.dataTransfer,
            data = {};
        if (dataTransfer && dataTransfer.files && dataTransfer.files.length) {
            e.preventDefault();
            let files;
            try {
                files = await _getDroppedFiles(dataTransfer);
            } catch (e) {
                files = e;
            }
            this.file = data.file = files[0];
            var originalTarget = e.originalEvent.target;
            if ($('#grouptiles').find(originalTarget).length !== 0) {
                var groupTile = $(originalTarget).closest('div[id^="group-"]');
                if (groupTile.data("group-type") === "query") {
                    await dhtmlx.alert(i18n.t("fileup.cannotuploadtoquerygroup"));
                    return;
                }
                var groupId = groupTile.attr('id');
                groupId = groupId.replace('group-', '');
                this.importToGroup = parseInt(groupId);
                this.groupName = $(groupTile).find(".group-title").text().trim();
            }
        }
        if (this.groupType === "query") {
            await dhtmlx.alert(i18n.t("fileup.cannotuploadtoquerygroup"));
            return;
        }
        this.addFile(e, data);
        if (this.groupIdProperty) {
            var $group = $("#group-title");
            this.groupName = $group.text() !== $group.attr("data-placeholder")
                ? $group.text()
                : `(${i18n.t("none")})`;
            this.importToGroup = parseInt(this.groupIdProperty);
        }
    }

    async pasteContactsHandler(event) {
        $("#upload-options").hide();
        if (this.groupType === "query") {
            await dhtmlx.alert(i18n.t("fileup.cannotuploadtoquerygroup"));
            return;
        }
        if (this.groupIdProperty) {
            var $group = $("#group-title");
            this.groupName = $group.text() !== $group.attr("data-placeholder")
                ? $group.text()
                : `(${i18n.t("none")})`;
            this.importToGroup = parseInt(this.groupIdProperty);
        }
        window.sessionStorage.removeItem("(paste)");
        //using lambdas to keep "this" of the outer scope
        const item = event.originalEvent.clipboardData.items[0];
        const asyncClipboard = makeAsync(item.getAsString.bind(item));
        const text = await asyncClipboard();

        const $paste = $(event.currentTarget);
        if (text) {
            $paste.val("");
            this.csvFileHandler(text);
        }
        location.href = "#paste";
    }

    importResultConfiguration(importData, innerView, totalCount) {

        const {
            importedContacts,
            erroneous,
            exceeding,
            duplicates,
            dateParsingFails,
            valid,
            newContacts,
            mergedContacts
        } = importData;

        const validContactsCount = valid > 0 ?
            i18n.t("fileup.validContacts", {
                count: valid
            }) : null;

        const importedContactsCount = importedContacts > 0 ?
            i18n.t("fileup.successfulcontactsreport", {
                count: importedContacts
            }) : null;

        const duplicateCount = duplicates > 0 ?
            i18n.t("fileup.duplicatescontactsreport", {
                count: duplicates
            }) : null;


        const erroneousCount = erroneous > 0 ?
            i18n.t("fileup.erroneouscontactsreport", {
                count: erroneous
            }) : null;


        const exceededCount = exceeding > 0 ?
            i18n.t("fileup.exceededcontactsreport", {
                count: exceeding
            }) : null;

        const dateParsingFailsCount = dateParsingFails > 0 ?
            i18n.t("fileup.dateparsingfailsreport", {
                count: dateParsingFails
            }) : null;

        const newContactsCount = newContacts > 0 ?
            i18n.t("fileup.newContacts", {
                count: newContacts
            }) : null;

        const mergedContactsCount = mergedContacts > 0 ?
            i18n.t("fileup.mergedContacts", {
                count: mergedContacts
            }) : null;

        innerView.updateContactsReport(totalCount, validContactsCount, duplicateCount, erroneousCount,
            importedContactsCount, exceededCount, dateParsingFailsCount, newContactsCount, mergedContactsCount);
    }

    @handles("progress:contactsParsing")
    parsingProgressHandler(data) {
        var progress = parseInt(data.loaded / data.total * 100, 10);
        let innerView = this.getOrCreateInnerView();
        innerView.updateProgress(progress);
        innerView.updateStatus(data.status);

        if(progress == 100) {
            $('#spinner-process-contacts').hide();
            $('#contact-parsing-finished').show();
        }
    }

    getPercentage(partitionNumber, jsonClass, totalPartitions) {
        return (partitionNumber * 2 - (jsonClass === "ParseContactsEvent" ? 1 : 0)) / (totalPartitions * 2);
    }

    getStatus(filename, importContactType) {
        if (filename) {
            return i18n.t("fileup.fileuploaded") + filename;
        } else if (importContactType) {
            return i18n.t("fileup.serviceContacts") + importContactType;
        } else {
            return "";
        }
    }

    @handles('progress:contactsImport')
    importProgressHandler(importData) {
        let innerView = this.getOrCreateInnerView();
        const {partitionNumber, jsonClass, totalPartitions, filename, valid, erroneous, importContactType} = importData;
        const totalContactImportCount = valid + erroneous;
        const percentageComplete = this.getPercentage(partitionNumber, jsonClass, totalPartitions);
        const finalProgress = 6 + percentageComplete;

        this.updateProgressIndicator(this.file, finalProgress, 7, this.getStatus(filename, importContactType));

        const totalCount = i18n.t("fileup.totalcontactsreport", {
            count: totalContactImportCount,
            number: partitionNumber,
            total: totalPartitions
        });
        this.importResultConfiguration(importData, innerView, totalCount);
        if (percentageComplete === 1)
            this.resetFile();
    }

    getOrCreateInnerView() {
        if (!this.file || !this.file.innerView) {
            this.file = {innerView: this.createProgressView()};
        }
        return this.file.innerView;
    }

    createProgressView() {
        this.fileRowViewsCounter++;
        this.$('.listview').show();
        return new FileRowView({
            el: this.$('.listview'),
            model: new Backbone.Model({
                output: "Uploading started",
                percent: 0,
                myID: this.fileRowViewsCounter
            })
        });
    }

    updateProgressIndicator(file, loaded, total, status) {
        const eventData = {
            loaded: loaded,
            total: total,
            status: status,
            file: file
        };
        this.trigger('progress:contactsParsing', eventData);
    }

    async submit(e, extraData) {

        if (!extraData)
            extraData = {
                file: {
                    innerView: this.createProgressView()
                }
            };

        this.updateProgressIndicator(extraData.file, 4, 7, i18n.t('fileup.uploading'));

        var mapping = {};
        var importToGroup = [];
        if (this.$(".add-blocked").prop("checked")) {
            importToGroup.push(1);
        }
        if (this.importToGroup)
            importToGroup.push(this.importToGroup);

        var permitUploading = false;

        $(".fieldmapper").each(function (_, field) {
            var tempValue = $(field).val();
            if (tempValue === "msisdn" || tempValue === "subscriber.email")
                permitUploading = true;

            if (tempValue !== "")
                mapping[tempValue] = $(field).data("index");

        });
        if (!permitUploading) {
            this.$('.delete').click();
            return false;
        }
        const data = [this.parsedData.headers.map(h => h.text)]
            .concat(this.parsedData.data.map(r => r.map(c => c.text)));

        this.formData = {
            mapping: mapping,
            importToGroup: importToGroup,
            defaultDateFormat: i18n.defaultDateFormatJava(),
            defaultTimeFormat: 'HH:mmZ',
            fileName: this.fileTitle,
            data: data,
            enc: this.enc
        };

        try {
            const {outcome, data} = await $.ajaxDefaultQ({
                url: '/CampaignCloud/Upload',
                type: 'POST',
                dataType: "json",
                contentType: 'application/json',
                data: JSON.stringify(this.formData)
            });
            if (outcome === "Error")
                throw data;

            this.updateProgressIndicator(extraData.file, 5, 7, i18n.t('fileup.importing'));

        } catch (err) {
            console.error(err);
            $('#spinner-process-contacts').hide();
            $('#contact-parsing-finished').hide();
            $('#process').hide();
            extraData.file.innerView.abort(i18n.t("fileup.failed"));

            location.href = "#";
        }
    }

    addFile(e, data) {
        $("#upload-options").hide();
        $("#contact-parsing-cant-be-done").hide();

        const {file} = data;
        if (!file || _.isArray(file)) return;

        const result = true;

        window.sessionStorage.removeItem(file.name);
        file.innerView = this.createProgressView();

        this.updateProgressIndicator(file, 0, 7, i18n.t('fileup.processing'));

        data.originalFile = file;

        this.unmatchedCols = 0;

        var newData = _.clone(data);
        newData.file = file;

        if (this.flag === 0) {
            this.flag = 1;

            if (!this.setParsingFunction(file)) {
                this.abort();
                return false;
            }

            //ToDo: add code to check file length and reject larger files.
            const maxFileSize = 1048576; // 1 MB

            if(file.size > maxFileSize) {
                var prettifiedFileSize = Handlebars.helpers.formatBytesSize(file.size, "si");
                var prettifiedMaxFileSize = Handlebars.helpers.formatBytesSize(maxFileSize, "si");

                // abort the parsing of the file
                this.abort();

                // show appropriate error messages
                $("#contact-parsing-cant-be-done").find(".error-message").text(i18n.t("fileup.fileTooBig", {maxSize: prettifiedMaxFileSize, fileSize: prettifiedFileSize}));
                $.Notify.error(i18n.t("fileup.fileTooBig", {maxSize: prettifiedMaxFileSize, fileSize: prettifiedFileSize}));
                $("#contact-parsing-cant-be-done").show();

                return false;
            }
            this.readFileRange(file, maxFileSize, this);

            location.href = "#upload";

        } else
            this.flag = 0;

        return result;

    }

    checkForFileAPISupport() {
        // Check for the various File API support:
        // True: Great success! All the File APIs are supported.
        // False: The File APIs are not fully supported in this browser.
        return window.File && window.FileReader && window.FileList && window.Blob;
    }

    readBlob(opt_startByte, opt_stopByte) {
        var files = document.getElementById('files').files;
        if (!files.length) {
            dhtmlx.alert(i18n.t("fileup.selectfile"));
            return;
        }

        var file = files[0];
        var start = parseInt(opt_startByte) || 0;
        var stop = parseInt(opt_stopByte) || file.size - 1;

        var reader = new FileReader();

        // If we use onloadend, we need to check the readyState.
        reader.onloadend = function (evt) {
            if (evt.target.readyState === FileReader.DONE) { // DONE == 2
                document.getElementById('byte_content').textContent = evt.target.result;
                document.getElementById('byte_range').textContent = ['Read bytes: ', start + 1, ' - ', stop + 1,
                    ' of ', file.size, ' byte file'
                ].join('');
            }
        };

        var blob = file.slice(start, stop + 1);
        reader.readAsBinaryString(blob);
    }

    readFileRange(file, range) {
        // Check if browser supports reading files.
        if (!this.fileAPISupport) {
            console.info("No File API Support");
            $("#contact-parsing-cant-be-done").find("error-message").text(i18n.t("fileup.browserNotSupport"));
            $("#contact-parsing-cant-be-done").show();
            $.Notify.error(i18n.t("fileup.browserNotSupport"));
            return false;
        }
        // Read file
        var fileReader = new window.FileReader();
        fileReader.onload = (e) => {
            if (this.fileType === "text" && this.manyUnrepresentableChars(e.target.result)) {
                fileReader.onload = (e) => {
                    this.ParsingFunction(e.target.result);
                };
                this.enc = "iso-8859-7";
                fileReader.readAsText(file, this.enc);
            } else {
                this.ParsingFunction(e.target.result);
            }
        };
        this.enc = "utf-8";
        if (this.fileType === "text") {
            fileReader.readAsText(file, this.enc);
        } else {
            fileReader.readAsBinaryString(file);
        }
        var blob = file.slice(0, range);
    }

    manyUnrepresentableChars(text) {
        var res = _.countBy(text, function (a) {
            return a === '\uFFFD';
        });
        return res.true > res.false * 0.01;
    }

    setParsingFunction(file) {

        var fileName = file.name;
        this.fileTitle = file.name;
        var fileNameArray = fileName.split(".");
        var fileExtension = fileNameArray[fileNameArray.length - 1].toLowerCase();
        var fileType = file.type;

        this.$('#parsed-file').html(Handlebars.partials.spinner);
        this.$('#parsed-file').find("i").removeClass("fg-white").addClass("fg-black");

        if (fileExtension === "txt" || fileType === "text/plain") {
            this.ParsingFunction = this.csvFileHandler;
            this.fileType = "text";
        }

        //csv
        else if (fileExtension === "csv" || fileType === "text/csv") {
            this.ParsingFunction = this.csvFileHandler;
            this.fileType = "text";
        }

        //XLSX / XLSM / XLSB / ODS / XLS
        else if (_.contains(["xlsx", "xlsm", "xslb", "ods", "xls"], fileExtension)) {
            this.ParsingFunction = this.spreadsheetFileHandler;
            this.fileType = "binary";
        }

        //vCard
        else if (fileExtension === "vcf" || fileType === "text/text/x-vcard") {
            this.ParsingFunction = this.vcardFileHandler;
            this.fileType = "text";
        }

        //ELSE
        else {
            $.Notify.error(i18n.t("fileup.notsupportedfile", {
                filename: fileExtension
            }));
            return false;
        }

        this.$('#parsed-file').css("max-height", "100vh");
        return true;
    }

    async parsedDataHandler(err, parsedData) {

        if (err) {
            this.abort();
            console.error(err);
            dhtmlx.alert(i18n.t("fileup.fileparseerror"));
            return;
        }
        if (parsedData.length <= 1) {
            this.abort();
            dhtmlx.alert(i18n.t("fileup.novalidcontactfile"));
            return;
        }
        //uncheck the T&C checkbox, in case of: paste/drop contacts & click T&C checkbox, press CANCEL, paste/drop contacts
        const $terms = $("#terms-and-conditions-checkbox");
        if ($terms.prop("checked"))
            $terms.click();

        let stats, data, meta;

        let calculatorConfig = {
            columnWording: i18n.t("fileup.column", {id: ""}),
            defaultDateFormat: i18n.defaultDateFormat()
        };

        if (typeof (Worker) !== "undefined") {
            if (typeof (this.metaWorker) == "undefined") {
                this.metaWorker = new MetaWorker();
            }
            let metaWorker = this.metaWorker;

            const channel = async function* () {
                let running = true;
                while (running) {
                    let promise = new Promise((res, rej) => {
                        metaWorker.onmessage = (event) => {
                            res(event.data);
                        };
                    });
                    let value = await promise;
                    if (!value.progress)
                        running = false;
                    yield value;
                }
            };

            metaWorker.postMessage({
                type: "init",
                payload: {
                    defaultCountryCode: callingcode.defaultCountryCode,
                    calculatorConfig
                }
            });
            metaWorker.postMessage({type: "data", payload: parsedData});

            for await (const msg of channel()) {
                if (msg.progress)
                    this.updateProgressIndicator(this.file, msg.progress, 7, i18n.t(msg.message));
                else {
                    stats = msg.stats;
                    data = msg.data;
                    meta = msg.meta;
                    this.metaWorker.terminate();
                    delete this.metaWorker;
                }
            }
        } else {
            calculatorInitializer(calculatorConfig);
            const metaCalculations = metaCalculator(parsedData);
            let running = true;
            while (running) {
                let promise = new Promise((res, rej) => setTimeout(function () {
                    res(metaCalculations.next());
                }, 0));
                const {value} = await promise;
                if (value.progress) {
                    this.updateProgressIndicator(this.file, value.progress, 7, i18n.t(value.message));
                } else {
                    stats = value.stats;
                    data = value.data;
                    meta = value.meta;
                    running = false;
                }
            }
        }
        this.parsedData = data;
        this.metaData = meta;

        this.$('#upload-options').show();
        this.showUploadOptions(data.data.length, stats.validContacts, stats.mobileStats, stats.emailStats, stats.dateStats, stats.countriesCount);
        this.prepareContactViewer(meta.mobPos, meta.emPos, meta.bDayPos);

        if (this.file && this.file.innerView)
            this.file.innerView.pauseProgress(null, "yellow");

        this.flag = 0;
    }

    async prepareContactViewer(mobPos, emPos, bDayPos) {
        let {headers, data} = this.parsedData,
            customFieldsResponse;
        try {
            customFieldsResponse = await $.ajaxDefaultQ({
                url: '/CampaignCloud/CustomFields',
                dataType: 'json',
                type: 'get'
            });
        } catch (e) {
            console.info(e);
            customFieldsResponse = [];
        }
        const rowHeight = 40, cellWidth = 200;
        const $subViewContainer = this.$('#parsed-file');

        const tableFromFile = uploaderTemplate({
            headers: headers,
            data: [],
            containerHeight: data.length * rowHeight,
            customFields: customFieldsResponse
        });
        $subViewContainer.html(tableFromFile);

        const v = Math.ceil($subViewContainer.width() / cellWidth);

        const $parsedTable = $("#parsed-file-table");
        const $dataWrapper = $parsedTable.find(".wrapper:nth-of-type(2)");
        const $wi = $dataWrapper.find(".wrapper-inner");
        renderVisibleContacts(0, 0);
        $wi.width(headers.length * cellWidth);

        let initialLeft = 0, initialTop = 0;

        function getCurrentViewportCoordinates(element) {
            const $ct = $(element);
            const currTop = $ct.scrollTop();
            const currLeft = $ct.scrollLeft();
            return {currTop, currLeft};
        }

        function calculateLowerBounds(currLeft, currTop) {
            const lowerXBound = Math.floor(currLeft / cellWidth);
            const lowerYBound = Math.floor(currTop / rowHeight);
            return {lowerXBound, lowerYBound};
        }

        function renderVisibleContacts(currLeft, currTop) {
            const perPage = {h: 10, v: v};
            const {lowerXBound, lowerYBound} = calculateLowerBounds(currLeft, currTop);
            const renderedContacts = contactRowPartial({
                headers: headers.slice(lowerXBound, lowerXBound + perPage.v + 1),
                data: data.slice(lowerYBound, lowerYBound + perPage.h + 1).map(r => r.slice(lowerXBound, lowerXBound + perPage.v + 1))
            });
            $wi.empty();
            $wi.append(renderedContacts);
        }

        $dataWrapper
            .scroll(ev => {
                const {currTop, currLeft} = getCurrentViewportCoordinates(ev.currentTarget);
                const {lowerXBound, lowerYBound} = calculateLowerBounds(currLeft, currTop);

                const dx = currLeft - initialLeft;
                const dy = currTop - initialTop;

                if (dx) {
                    //syncronize scrolling of headers and content
                    $parsedTable
                        .find(".wrapper:nth-of-type(1)")
                        .scrollLeft(currLeft);

                    const leftMargin = lowerXBound * cellWidth;
                    $wi.css("margin-left", `${leftMargin}px`);
                    $wi.width(headers.length * cellWidth - leftMargin);
                }

                if (dy) {
                    const topMargin = lowerYBound * rowHeight;
                    $wi.css("margin-top", `${topMargin}px`);
                    $wi.height(data.length * rowHeight - topMargin);
                }
                renderVisibleContacts(currLeft, currTop);
                initialTop = currTop;
                initialLeft = currLeft;
            });

        let prevVal;
        const $fieldmapper = this.$('.fieldmapper');
        $fieldmapper
            .on('focus', event => prevVal = event.currentTarget.value)
            .change(event => {
                const elem = event.currentTarget;
                const currentVal = $(elem).val();

                /**
                *  After the first `change` event of each select, we mark it as "valid" (selected value).
                *  We also trigger a `change` event, in order to update the values of the predefined custom fields.
                *  So we add a check here to ensure that, in that case, the `change` event will not be TRIGGERED directly
                *  (triggered directly can happen when: currentVal == "TLD_NO_MATCH" or currentVal == prevVal)
                *
                **/
                if(currentVal == "TLD_NO_MATCH" || currentVal == prevVal) {
                    event.preventDefault();
                    return false;
                }

                const $mcOptionsContainer = $($(elem).parent().find(".customFieldsMultipleChoiceOptions")[0]);
                const $mcOptionsContainerBtn = $($(elem).parent().find(".customFieldsMultipleChoiceOptionsBtn")[0]);
                const $mcOptionsCloseBtn = $($(elem).parent().find(".closeOptions")[0]);

                $mcOptionsContainerBtn.off("click").on("click", function() {
                    if($mcOptionsContainer.css("display") == "none") {
                        // first hide all other that might already be visible
                        $(".customFieldsMultipleChoiceOptions").hide();

                        $mcOptionsContainer.show();
                    }else {
                        $mcOptionsContainer.hide();
                    }
                });
                $mcOptionsCloseBtn.off("click").on("click", function() {
                    $(this).parent().toggle();
                });

                const type = $($(elem)[0]).find(":selected").data("type");
                const options = $($(elem)[0]).find(":selected").data("options");
                const val = $($(elem)[0]).val();

                if(type == "multipleChoice") {
                    var mcOptions = options.replace(/,/g,', ');

                    $mcOptionsContainer.find(".cfName").text(val);
                    $mcOptionsContainer.find(".optionsText").text(mcOptions);
                    $mcOptionsContainerBtn.show();
                }else {
                    $mcOptionsContainer.find(".cfName").text('');
                    $mcOptionsContainer.find(".optionsText").text('');
                    $mcOptionsContainerBtn.hide();
                }

                const changeTypedField = (type) => {
                    const prevFieldIndex = _.findIndex(this.parsedData.headers, h => h.type === type);
                    const fmapIndex = $(".fieldmapper").index(elem);
                    if (prevFieldIndex > -1)
                        this.parsedData.headers[prevFieldIndex].type = "text";
                    this.parsedData.headers[fmapIndex].type = type;
                    let posAttr = {
                        "mobile": "mobPos",
                        "email": "emPos",
                        "date": "bDayPos"
                    };
                    const {mobPos, emPos, bDayPos} = this.parsedData.headers.reduce((obj, h, i) => {
                        let attr = posAttr[h.type];
                        if (attr)
                            obj[attr] = i;
                        return obj;
                    }, {});
                    const stats = calculateStats(this.parsedData.data, mobPos, emPos, bDayPos);
                    let allContactsCount = this.parsedData.data.length;
                    const invalidContactsCount = allContactsCount - stats.validContacts;
                    const importStats = importStatsPartial({
                        contacts: allContactsCount,
                        validContacts: stats.validContacts,
                        invalidContacts: invalidContactsCount,
                        filename: this.fileTitle,
                        dateStats: stats.dateStats,
                        mobileStats: stats.mobileStats,
                        emailStats: stats.emailStats,
                        flags: _.pairs(stats.countriesCount),
                        groupName: this.groupName
                    });
                    $("#import-stats").html(importStats);
                    this.showUnmatchedCols();
                    const {currLeft, currTop} = getCurrentViewportCoordinates($dataWrapper);
                    renderVisibleContacts(currLeft, currTop);
                };

                switch (elem.value) {
                    case "createCustomField":
                        var customFieldsView = new CustomFieldsView();
                        customFieldsView.showNewCustomFieldForm();
                        $('#cancelCreationOfCustomField').off().click(customFieldsView.cancelCreationOfCustomField);
                        $('#submitNewCustomField').off().click(customFieldsView.submitNewCustomField.bind(customFieldsView, $fieldmapper, elem, this));

                        $("#type").off().change(customFieldsView.showHideMultipleChoiceOptions.bind(customFieldsView));
                        $(".addMCCFAnswer").off().click(customFieldsView.addMCCFAnswer.bind(customFieldsView));
                        $(".deleteMCCFAnswer").off().click(customFieldsView.deleteMCCFAnswer.bind(customFieldsView));

                        break;
                    case "msisdn":
                        changeTypedField("mobile");
                        break;
                    case "subscriber.email":
                        changeTypedField("email");
                        break;
                    case "subscriber.birthday":
                        changeTypedField("date");
                        break;
                }
                if (prevVal === "TLD_NO_MATCH") {
                    if (--this.unmatchedCols === 0) {
                        this.$('.unmatched-warning-message').hide();
                        this.toggleDisabilityOfUploadButton();
                    }
                    this.showUnmatchedCols();
                }
                $fieldmapper.not(elem).filter((idx, el) => el.value === elem.value).val("");
                $(".custom-field-warning-message").hide();
                this.validateCustomFields($(elem));
                $(elem).removeClass("bg-ripeSquash")
                    .removeClass("fg-darkCrimson")
                    .addClass("bg-freshCabbage")
                    .addClass("fg-darkEmerald");
            });

        this.$('.columnheader').each((index, element) => {
            const mapper = this.$('.fieldmapper').eq(index);
            const theIndex = mapper.data('index');
            const selectDetectedField = (val) => mapper
                .addClass("bg-freshCabbage")
                .addClass("fg-darkEmerald")
                .find(`option[value="${val}"]`)
                .prop('selected', true);

            if (theIndex === mobPos) {
                selectDetectedField("msisdn");
            } else if (theIndex === emPos) {
                selectDetectedField("subscriber.email");
            } else if (theIndex === bDayPos) {
                selectDetectedField("subscriber.dateOfBirth");
            } else {
                const filterLambda = (fid, fel) => {
                    var headerText = $(element).text().trim();
                    var mapperText = $(fel).text();
                    var mapperVal = $(fel).val();

                    switch (mapperVal) {
                        case "msisdn":
                            return !mobPos && /mobile( number| phone)?/i.test(headerText);
                        case "subscriber.email":
                            return !emPos && /e(-)?mail( address)/i.test(headerText);
                        case "subscriber.streetAddress":
                            return /home address/i.test(headerText);
                        case "subscriber.dateOfBirth":
                            return !bDayPos && /birth( )?(date|day)/i.test(headerText);
                        case "subscriber.profession":
                            return headerText.toLowerCase() === "profession";
                        case "subscriber.firstName":
                            return ["first name", "firstname", "name"].includes(headerText.toLowerCase());
                        case "subscriber.lastName":
                            return ["last name", "lastname", "surname"].includes(headerText.toLowerCase());
                        case "subscriber.country":
                            return headerText.toLowerCase() === "country";
                        case "subscriber.gender":
                            return headerText.toLowerCase() === "gender";
                        case "subscriber.preferredChannel":
                            return /preferred( )?channel/i.test(headerText);
                        default:
                            return (headerText.toLowerCase() === mapperVal.toLowerCase() &&
                                customFieldsResponse.find((val) => val.name === mapperVal))
                                ? true
                                : [mapperText.toLowerCase(), mapperVal.toLowerCase()]
                                    .includes(headerText.toLowerCase());
                    }
                };

                var detectedHeader = mapper.find('option').filter(filterLambda);
                detectedHeader.prop('selected', true);
                if (detectedHeader.length > 0)
                    mapper.addClass("bg-freshCabbage").addClass("fg-darkEmerald");
                else {
                    mapper.addClass("bg-ripeSquash").addClass("fg-darkCrimson");
                    this.unmatchedCols++;
                }
                this.validateCustomFields(mapper);

                if (detectedHeader.data('type') === "multipleChoice") {
                    mapper.trigger("change"); // trigger change on select, so that the multiple choice options will be made visible
                }
            }
        });
        this.showUnmatchedCols();
    }

    /*Todo validate elsewhere, using value.valid*/
    validateCustomFields(mapper) {
        var self = this;
        const index = mapper.data("index");
        const type = mapper.find('option:selected').data('type');
        const name = mapper.val();
        if (type) {
            this.parsedData.data.forEach((datum, i) => {
                const {text} = datum[index];
                if (type === "number") {
                    this.checkNotANumber(text, index, name, type);
                } else if (type === "date") {
                    self.parsedData.data[i][index].text = this.checkAndGetDateInMillis(text, index, name, type);
                }
            });
        }
    }

    checkAndGetDateInMillis(value, index, name, type) {
        if(!value)
            return;

        // convert value to String, because the value passed in the parameters is in mills
        value = value.replace(this.regexHelpers.excessiveSpaces, '');
        var d = moment(value);
        if (!d.isValid()) {
            this.showWarning(index, name, type);
            return "";
        }
        return d.valueOf();
    }

    checkNotANumber(value, index, name, type) {
        var re = /^-?[0-9]+([.][0-9]+)?$/g;
        if (value !== '' && !re.test(value)) {
            this.showWarning(index, name, type);
        }
    }

    showWarning(index, name, type) {
        var warnMsg = i18n.t("fileup.customFieldWarning", {index: index + 1, name: name, type: type});
        var $custom = $('.custom-field-warning-message');
        $custom.text(warnMsg).prepend($('<span id="custom-warning">').html('<i class="icon-warning on-right">&nbsp</i>'));
        $custom.show();
        $('#custom-warning').show();
    }

    async csvFileHandler(readFile) {
        try {
            const results = await asyncPapaParse(readFile, {
                skipEmptyLines: true
            });
            const {data, errors} = results;
            const {aborted} = results.meta;
            const err = aborted ? errors : null;
            const maxCols = data.map(r => r.length).reduce((m, r) => Math.max(m, r));

            const [datum] = data;
            if (datum && this.guessHeaderless(datum.toString())) {
                data.unshift(_.times(maxCols, i => i18n.t("fileup.column", {id: i})));
            } else {
                data[0] = data[0].filter(_.identity); //this is dumb
            }
            await this.parsedDataHandler(err, data);
        } catch (e) {
            console.log(e);
        }
    }

    async spreadsheetFileHandler(readFile) {
        var workbook = xlsx.read(readFile, {
            type: 'binary'
        });

        if (workbook.SheetNames.length > 1) {
            this.showSheetNamesSelector(workbook);
        } else if (workbook.SheetNames.length === 1) {
            this.parseSheetData(workbook, 0);
        } else {
            await dhtmlx.alert(i18n.t("fileup.emptySheet"));
            location.href = "/CampaignCloud/cloudui/home/Contacts.htm";
        }
    }

    parseSheetData(workbook, selectedSheet) {

        const first_sheet_name = isNaN(selectedSheet) ? selectedSheet : workbook.SheetNames[selectedSheet];
        const worksheet = workbook.Sheets[first_sheet_name];
        const parsedData = this.getXlsxHeaders(worksheet);
        let oa;
        if (this.guessHeaderless(parsedData.toString())) {
            var headersRange = this.getSheetColumnNumber(this.getSheetRange(worksheet).maxColumn);
            //fill parsed data columns, to avoid having them being ignored.
            var defaultHeaders = [];
            for (var i = 0; i < headersRange; i++)
                defaultHeaders.push(i18n.t("fileup.column", {id: i}));
            parsedData[0] = defaultHeaders;
            oa = xlsx.utils.sheet_to_row_object_array(worksheet, {header: defaultHeaders});
        } else {
            oa = xlsx.utils.sheet_to_row_object_array(worksheet);
        }

        _.each(oa, function (row) {
            var mapped = _.map(parsedData[0], function (key) {
                return row[key] ? row[key] : "";
            });
            parsedData.push(mapped);
        });

        this.parsedDataHandler(undefined, parsedData);

    }

    async showSheetNamesSelector(workbook) {
        const nonEmptySheets = workbook.SheetNames.filter(sName => workbook.Sheets[sName]["!ref"]);
        if (nonEmptySheets.length === 0) {
            await dhtmlx.alert(i18n.t("fileup.emptySheet"));
        } else if (nonEmptySheets.length === 1) {
            this.parseSheetData(workbook, nonEmptySheets[0]);
        } else {
            const modalButtons = nonEmptySheets.map(sName => `<i class="icon-tellody-excel1 no-margin" ></i> ${sName}`);
            modalButtons.push(`<i class="icon-cancel-2 no-margin" ></i> ${i18n.t("cancelbtn")}`);

            const result = await dhtmlx.modalbox({
                title: i18n.t('fileup.selectXlsSheetTitle'),
                text: i18n.t('fileup.selectXlsSheet'),
                buttons: modalButtons
            });

            if ((modalButtons.length - 1).toString() !== result) {
                this.parseSheetData(workbook, nonEmptySheets[result]);
            } else {//cancel clicked
                location.href = "/CampaignCloud/cloudui/home/Contacts.htm";
            }
        }
    }

    showUnmatchedCols() {
        if (this.unmatchedCols > 0) {
            var unmatchedMsg = i18n.t("fileup.unmatchedwarning", {count: this.unmatchedCols});
            var skip = i18n.t("fileup.skip", {count: this.unmatchedCols});
            this.$('.unmatched-warning-message')
                .text(unmatchedMsg)
                .append(`<a href="#" class="skip-btn">&nbsp${skip}<a>`)
                .prepend($('<span id="date-warning">').html('<i class="icon-warning on-right">&nbsp</i>'));
            this.$('.unmatched-warning-message').show();
        } else {
            this.$('.unmatched-warning-message').hide();
        }
    }

    showUploadOptions(allContactsCount, validContactsCount, mobileStats, mailStats, dateStats, countriesCnt) {
        const invalidContactsCount = allContactsCount - validContactsCount;
        const uploadOptions = uploadOptionsTemplate({
            contacts: allContactsCount,
            validContacts: validContactsCount,
            invalidContacts: invalidContactsCount,
            filename: this.fileTitle,
            dateStats: dateStats,
            mobileStats: mobileStats,
            emailStats: mailStats,
            flags: _.pairs(countriesCnt),
            groupName: this.groupName
        });

        this.$("#upload-options").html(uploadOptions);

        if (this.importToGroup === 1) {
            this.$('.add-blocked').prop("checked", true);
            this.$('.add-blocked').attr('disabled', 'disabled');
        } else {
            this.$(".add-blocked").prop("checked", false);
            this.$('.add-blocked').removeAttr('disabled');
            if (this.groupIdProperty !== null) {
                this.importToGroup = parseInt(this.groupIdProperty);
            }
        }

        const extendedEventHash = _.extend({
            'click .start': (e) => {
                console.log("click run");
                if (this.parsedData) {
                    console.log("and data not null");
                    let permitUploading = $(".fieldmapper")
                        .toArray()
                        .reduce((memo, v) => memo || ["msisdn", "subscriber.email"].includes($(v).val()), true);
                    if (!permitUploading) {
                        $.Notify.error(i18n.t("fileup.matchingprompt"));
                        return false;
                    }

                    this.submit(e, {file: this.file});

                    $(this).hide();

                    this.$('#upload-options').hide();
                    this.$('#parsed-file').empty();
                    this.$('#parsed-file').css("height", "initial");
                    delete this.parsedData;
                }
            },
            'click .delete': () => {
                delete this.parsedData;
                this.abort();
            },
            'change #terms-and-conditions-checkbox': "toggleDisabilityOfUploadButton"
        }, this.events);

        this.delegateEvents(extendedEventHash);
    }

    vcardFileHandler(data) {
        var vcards = [
            ["First Name", "Last Name", "Mobile Phone", "Email Address"]
        ];
        data = data.replace(/.*TEL:/g, "TEL;TYPE=CELL:");
        data = data.replace(/;CELL:/g, ";TYPE=CELL:");
        data = data.replace(/;CELL;/g, ";TYPE=CELL;");
        data = data.replace(/.*EMAIL:/g, "EMAIL;TYPE=INTERNET:");
        data = data.replace(/;INTERNET:/g, ";TYPE=INTERNET:");
        data = data.replace(/;INTERNET;/g, ";TYPE=INTERNET;");

        data = data.split('\n').map(function (s) {
            var i = s.indexOf(':');
            if (i > -1) {
                return s.substring(0, i).toUpperCase() + s.substring(i);
            } else {
                return s;
            }
        }).join('\n');

        vcardjs.VCF.parse(data, vcard => {
            var a = this.vcfToCsv(vcard);
            vcards.push(a);
        });
        this.parsedDataHandler(undefined, vcards);

    }

//TODO check here to use the detected cell numbers
    vcfToCsv(vcard) {
        var fn = "";
        var gn = "";
        var telNum = "";
        var eml = "";

        if ((vcard.n) && (vcard.n["given-name"])) {
            gn = vcard.n["given-name"].join(" ");
        }
        if ((vcard.n) && (vcard.n["family-name"])) {
            fn = vcard.n["family-name"].join(" ");
        }
        if (vcard.email) {
            var re = emailRegex;
            for (var i = 0; i < vcard.email.length; i++) {
                if (!eml) {
                    var e = vcard.email[i].value.replace(this.regexHelpers.excessiveSpaces, '');
                    if (e.length && re.test(e)) {
                        eml = e;
                    }
                }
                if ((vcard.email[i].type) && (vcard.email[i].type === "INTERNET")) {
                    eml = vcard.email[i].value;
                    eml = eml.replace(this.regexHelpers.excessiveSpaces, '');
                    if ((re.test(eml)) && (eml.length)) {
                        break;
                    }

                }
            }
        }
        if (vcard.tel) {
            var numberType;
            for (var j = 0; j < vcard.tel.length; j++) {
                if (!telNum) {
                    var t = vcard.tel[j].value.replace(/\s/g, '').replace(/[\.,-\/#!$%\^&\*;:{}=\-_`~()@\?><\[\]]/g, '');
                    try {
                        const parsedPhoneNum = callingcode.parseAndKeepRawInput(t);
                        var c = callingcode.getRegionCodeForNumber(parsedPhoneNum, callingcode.defaultCountryCode);
                        if (c) {
                            numberType = callingcode.getNumberType(parsedPhoneNum, c);
                            if (numberType === 1 || numberType === 2) {
                                telNum = t;
                            }
                        }
                    } catch (e) {
                    }
                }
                if ((vcard.tel[j].type) && (vcard.tel[j].type === "CELL")) {
                    telNum = vcard.tel[j].value;
                    telNum = telNum.replace(/\s/g, '');
                    telNum = telNum.replace(/[\.,-\/#!$%\^&\*;:{}=\-_`~()@\?><\[\]]/g, '');

                    var m;
                    const parsedPhoneNum = callingcode.parseAndKeepRawInput(telNum);
                    try {
                        m = callingcode.getRegionCodeForNumber(parsedPhoneNum, callingcode.defaultCountryCode);
                    } catch (e) {
                        console.log(e);
                    }
                    if (m) {
                        numberType = callingcode.getNumberType(parsedPhoneNum, m);
                        if (numberType === 1 || numberType === 2) {
                            break;

                        }
                    }
                }
            }
        }
        return [gn, fn, telNum, eml];
    }

    updateCallback(attributeName, value, outcome, e, settings) {
        if ("OK" === outcome) {
            var newHtml = ("true" === value.toString()) ? "true" : "";
            $(e).find('.hidden').html(newHtml);
            if (value) {
                $(e).removeClass('busy');
                $(e).addClass('available');
            } else {
                $(e).addClass('busy');
                $(e).removeClass('available');
            }
        }
        return super.updateCallback(attributeName, value, outcome, e, settings);
    }

    @on('click .unmatched-warning-message .skip-btn')
    skipUnmatchedCols(e) {
        e.preventDefault();
        $('.fieldmapper').each((idx, el) => {
            var $el = $(el);
            if ($el.find('option:selected').val() === "TLD_NO_MATCH") {
                $el.val("").trigger('change');
                if (--this.unmatchedCols === 0) {
                    this.$('.unmatched-warning-message').hide();
                    this.toggleDisabilityOfUploadButton();
                }
            }
        });
    }

    toggleDisabilityOfUploadButton() {
        var $checkBox = this.$("#terms-and-conditions-checkbox");
        var checked = $checkBox.is(":checked");
        $("#startUploadButton").prop("disabled", !checked || this.unmatchedCols > 0); //toggle `start upload` button
    }

    toggleHelpAccordionText() {
        if (location.href.indexOf("Group") === -1) {
            $("#contactsAndGroupHelpPromptDiv").css("display", "block");
            $("#groupHelpPromptDiv").css("display", "none");
        } else {
            $("#groupHelpPromptDiv").css("display", "block");
            $("#contactsAndGroupHelpPromptDiv").css("display", "none");
        }
        var selector = $("#file-upload-container");
        setTimeout(function () {
            if (!selector.find(".heading").hasClass("collapsed")) {

                selector.find("#heading-text").text(i18n.t("dashboard.helpaccordionpromptClose"));
            } else {
                selector.find("#heading-text").text(i18n.t("contacts.importprompt"));
            }
        }, 0);
    }

    @on('click #labelForBrowseFile')
    browseFile() {
        $("#brf").click();
    }

    hide() {
        this.$el.parent().parent().hide();
    }

    show() {
        this.$el.parent().parent().show();
    }

    @on('click #file-example')
    fileExample() {
        const wrappedNumber = callingcode.getExampleNumberForType(callingcode.defaultCountryCode, 1);
        var exampleNumber = callingcode.formatOutOfCountryCallingNumber(wrappedNumber);
        var data = [
            ["First Name", "Last Name", "E-mail Address", "Mobile Phone", "Contact Address", "Birthday", "Profession", "Gender"],
            [
                i18n.t("fileup.examplefirstname"),
                i18n.t("fileup.examplelastname"),
                "example@example.com",
                exampleNumber,
                i18n.t("fileup.exampleaddress"),
                "09/09/1980",
                i18n.t("fileup.exampleprofession"),
                "0"
            ]
        ];
        var csvContent = "data:text/csv;charset=utf-8,";
        data.forEach(function (infoArray, index) {

            var dataString = infoArray.join("\t");
            csvContent += index < data.length ? dataString + "\r\n" : dataString; // Windows-friendly

        });
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "example.txt");
        document.body.appendChild(link);

        link.click();
    }

    refreshContacts() {
        if (this.importContactId !== null) {
            this.isImportContactCompleted.call(this);
        }
    }

    * pollImportContactHistory(importContactId) {
        while (true) {
            yield $.ajaxDefaultQ({
                type: "POST",
                url: "/CampaignCloud/Upload/getImportContactHistory",
                dataType: "json",
                data: {
                    importContactId: importContactId
                }
            });
        }
    }

    async isImportContactCompleted(generator) {
        if (!generator)
            generator = this.pollImportContactHistory(this.importContactId);

        const {value: promise} = generator.next();
        try {
            const importHistoryData = await promise;
            let importProvider;
            if (!importHistoryData.completed) {
                const msg = {
                    file: "contacts.fileimport",
                    gmail: "contacts.googleprovider",
                    yahoo: "contacts.yahooprovider",
                    hotmail: "contacts.hotmailprovider"
                };

                importProvider = i18n.t(msg[importHistoryData.type.toLowerCase()]);
                $('#spinner-import-contacts').show().find('span').text(i18n.t("contacts.waitingimportcontacts") + importProvider);
            } else {
                $('#spinner-import-contacts').hide();
                this.$('.listview').show();
                var innerView = new FileRowView({
                    el: this.$('.listview'),
                    model: new Backbone.Model({
                        name: importProvider,
                        output: "Importing started",
                        percent: 0,
                        myID: importHistoryData.importContactHistoryId
                    })
                });
                var title = "";
                if (importHistoryData.type.toLowerCase() === 'Gmail'.toLowerCase()) {
                    title = i18n.t("contacts.googleprovider");
                    innerView.updateIcon('icon-google-plus fg-red');
                } else if (importHistoryData.type.toLowerCase() === 'Yahoo'.toLowerCase()) {
                    title = i18n.t("contacts.yahooprovider");
                    innerView.updateIcon('icon-yahoo fg-violet');
                } else if (importHistoryData.type.toLowerCase() === 'Hotmail'.toLowerCase()) {
                    innerView.updateIcon('icon-tellody-hotmail fg-orange');
                    title = i18n.t("contacts.hotmailprovider");
                }
                innerView.updateTitle(title);
                innerView.updateStatus(i18n.t("contacts.successmessage"));
                innerView.updateProgress(100);
                var totalCount = i18n.t("fileup.totalcontactsreport", {
                    count: importHistoryData.totalContactImportCount,
                    number: importHistoryData.partitionNumber,
                    total: importHistoryData.totalPartitions
                });
                this.importResultConfiguration(importHistoryData, innerView, totalCount);
                location.href = "#";
                return;
            }
        } catch (e) {
            console.info("Req: /CampaignCloud/Upload/getImportContactHistory :: error");
        }
        setTimeout(() => {
            this.isImportContactCompleted.call(this, generator);
        }, 3000);
    }

    getXlsxHeaders(worksheet) {
        //get a clone of the worksheet, set the range to be only the first row, which contains the headers
        var tempSheet = $.extend({}, worksheet);
        //make the "range" (!ref) be like --> "A1:G1"
        var headersRange = this.getSheetRange(worksheet).headersRange;


        tempSheet['!ref'] = headersRange.firstCell + ":" + headersRange.lastCell;
        //header: 1, returns the result into an array of arrays, which on [0], contains an array with the header names
        return xlsx.utils.sheet_to_json(tempSheet, {header: 1});
    }

    getSheetRange(worksheet) {
        var startingRow = worksheet['!ref'].substring(0, worksheet['!ref'].indexOf(":")).replace(/[^0-9]*/g, '');
        var endingRow = worksheet['!ref'].substring(worksheet['!ref'].indexOf(":") + 1).replace(/[^0-9]*/g, '');
        var startingColumn = worksheet['!ref'].substring(0, worksheet['!ref'].indexOf(":")).replace(/[0-9]*/g, '');
        var endingColumn = worksheet['!ref'].substring(worksheet['!ref'].indexOf(":") + 1).replace(/[0-9]*/g, '');

        var headersFirstCell = worksheet['!ref'].substring(0, worksheet['!ref'].indexOf(":")).replace(/[0-9]*/g, '') + startingRow;
        var headersLastCell = worksheet['!ref'].substring(worksheet['!ref'].indexOf(":") + 1).replace(/[0-9]*/g, '') + startingRow;

        return {
            "headersRange": {"firstCell": headersFirstCell, "lastCell": headersLastCell},
            "minRow": startingRow,      //number
            "maxRow": endingRow,        //number
            "minColumn": startingColumn,//upper case letter
            "maxColumn": endingColumn   //upper case letter
        };
    }

    getSheetColumnNumber(columnName) {
        var base = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ', i, j, result = 0;

        for (i = 0, j = columnName.length - 1; i < columnName.length; i += 1, j -= 1)
            result += Math.pow(base.length, j) * (base.indexOf(columnName[i]) + 1);

        return result;
    }

    guessHeaderless(firstLine) {
        if (!firstLine || firstLine.trim().length === 0)
            return true;

        var probableHeaderNames = [
            //en - universal
            "firstname",
            "lastname",
            "email",
            "msisdn",
            "mobile",
            "address",
            "phone",
            "profession",
            "city",
            "country",
            "postalcode",
            "birthday",
            "gender",

            //el
            "ονομα",
            "επωνυμο",
            "κινητο",
            "διευθυνση",
            "τηλεφωνο",
            "επαγγελμα",
            "πολη",
            "χωρα",
            "ταχυδρομικοςκωδικας",
            "γενεθλια",
            "φυλο"
        ];
        return !_.find(probableHeaderNames, headerName => firstLine
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\s_\-\u0300-\u036f]/g, '')
            .includes(headerName));
    }
}

export default FileUploadView;
